import restGql from 'graphql-tag';

export const SessionsQuery = restGql`#graphql
    query Sessions($institutionId: String!, $validOn: String!, $includeDiscontinued: Boolean!, $behaviors: Number!, $includeHiddenByUser: Boolean!) {
        result(institutionId: $institutionId, validOn: $validOn, includeDiscontinued: $includeDiscontinued, behaviors:$behaviors, includeHiddenByUser:$includeHiddenByUser)@rest(type: "SessionsResponse", path: "/v2/sessions?institutionId={args.institutionId}&validOn={args.validOn}&includeDiscontinued={args.includeDiscontinued}&behaviors={args.behaviors}&includeHiddenByUser={args.includeHiddenByUser}") {
            sessions{
                id
                title
                sessionType
                validFrom
                validTo
                flexibleHours
                pricing{
                    ageGroupId
                    period
                    price
                    pricing
                    pricingGroupId
                }
                availability{
                    day
                    start
                    end
                }
                hiddenByUser
            }
        }
    }
`;
